// src/App/Pages/Casino/Home.js
import React, { Component, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import { BRAND, decode, encode, getUID, isMobile, sendNotfication } from "../../../Helper";
import { withCookies } from 'react-cookie';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { ChevronLeft, ChevronRight, Play } from "lucide-react";
import C from '../../../../src/Constant';
import socket from '../../../Socket';
import storage from "../../../Storage";
import { useSiteConfig } from "../../../hooks/useSiteConfig";
import PaymentBar from "../../Components/PaymentBar";
import MobilePaymentBR from "../../Components/MobilePaymetBar";
import CasinoLeaderboard from "../../Components/HelloGamesTable";
import GameProviders from "../Parts/Home/Provider";

/* ---------------- Styled components (kept / adapted from your original) ---------------- */

const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: #1b2336;
`;

const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: ${(props) => (props.loading ? 'none' : 'block')};
`;
const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 140px;
  height: 140px;
  border-radius:20px;

  @media (min-width: 467px) {
    width: 188px;
    height: 188px;
  }
`;


const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: none;
  border: none;
  color: #000;
  font-size: 24px;
  cursor: pointer;
`;

const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #000;
`;

const SliderContainer = styled.div`
  width: 100%;
  max-width: 800px;
  position: relative;
  overflow: hidden;
`;

const SliderTrack = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => props.translate}%);
`;

const SliderItem = styled.div`
  flex: 0 0 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  background-color: #f2f2f2;
`;

const SliderNavigation = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
`;

const NavigationButton = styled.button`
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  outline: none;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
`;
const LottoCard = styled.button`
  background-color: #0E1423;
 border-radius:12px;
 width:100%
   margin-bottom:12px;
`;

const ContainerPlay = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    // padding: 10px;
    justify-content: center;
  }

  @media (max-width: 767px) {
    gap: 8px;
    // padding: 5px;

    
  }
`;
const SkeletonLoader = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(190, 190, 190, 0.2) 25%,
    rgba(129, 129, 129, 0.24) 37%,
    rgba(190, 190, 190, 0.2) 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 8px;

  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr); // 8 items per row
  gap: 12px; // Adjust gap between items as needed
   @media (max-width: 767px) {
    // gap: 8px;
   grid-template-columns: repeat(3, 1fr); // 8 items per row

    
  }
 
`;

const PickOptionWrapper = styled.div`
  flex: 0 0 auto;
  width: calc(50% - 6px);
  scroll-snap-align: start;

  @media (min-width: 768px) {
    width: 100%;
  }
`;


const HiddenOnSmallScreens = styled.div`
display:flex;
  @media (max-width: 768px) {
    display: none;
  }
`;

const GamesWrapper = styled.div`
  background-color: #1C1E22;
  padding: 2px;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  position: relative;
  margin-top: 40px !important;
 
  @media (max-width: 768px) {
    margin-top: 100px !important;
  }
`;


const GamesTopWrapper = styled.div`
  background-color: #1C1E22;
  padding: 2px;
  border-radius: 0 20px 20px 20px; /* top-left | top-right | bottom-right | bottom-left */
  position: relative;
  margin-top: 40px !important;
   margin-top: 100px !important;
  @media (max-width: 768px) {
    margin-top: 100px !important;
  }
`;
const GridContainer = styled.div`
  display: grid;
  gap: 10px;
  padding: 0rem;
  margin:12px 12px;
  width: 100%;
  // Mobile view (2 columns)
  grid-template-columns: repeat(2, 1fr);
  // Tablet view (3 columns)
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  // Desktop view (4 columns)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;
const GridItem = styled.div`
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;


const GridContainerNew = styled.div`
  display: grid;
  gap: 10px;
  padding: 0rem;
  margin:12px 12px;
  width: 100%;
  padding-right:17px;
  // Mobile view (2 columns)
  grid-template-columns: repeat(2, 1fr) !important;
  // Tablet view (3 columns)
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  // Desktop view (4 columns)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr) !important;
  }
`;
const GridItemNew = styled.div`
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;

const AllButtonTopTitleContainer = styled.div`
  background-color: #1C1E22;
  border-radius: 15px;
  display:flex;
  justify-caontent:center;
  align-items:center;
  color:#7F898C;
  font-weight:bold;
  z-index: 1;
  padding: 5px 23px;
  margin: 0;
  cursor:pointer;
`;

const NavItem = styled.button`
  display: flex;
  align-items: center;
  background-color: ${props => props.active ? '#23262B' : 'transparent'};
  color: ${props => props.active ? '#ffffff' : '#888888'};
  border: none;
  padding: 12px 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
 

  &:hover {
    background-color: #2a2a2a;
  }
`;

const NavBar = styled.nav`
  display: inline-flex; // Changed to inline-flex
  justify-content: flex-end;
  background-color: #191A1E;
  padding: 4px;
  border-radius: 26px;
  overflow: hidden; // Changed from overflow-x
`;

const NavBarEnd = styled.div`
  display: flex;
  width: 100%;
`;

const TabSwitcher = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
 background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s ease;
 
  

`;

const Tab = styled.button`
  background-color: ${props => props.active ? '#2c3137' : 'transparent'};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 26px;
  cursor: pointer;
  font-size: 16px;
  margin-right: 10px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${props => props.active ? '#2c3137' : '#1c1e22'};
  }
`;

const FlexArrange = styled.div`
  display: flex;
  align-items: center;
`;

const TabImage = styled.img`
  height: 28px;
  width: 28px;
  object-fit: contain;
  margin-right: 8px;
  filter: ${props => props.active ? 'none' : 'grayscale(100%)'};
  transition: filter 0.3s ease;
`;

const TabText = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderContent = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin:12px 0px;
`;

const IconBg = styled.div`
  padding: 6px 8px;
  background-color:#03030F;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    background-color: #4a5354;
  }
`;

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  // margin-top: 20px;
`;

const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 11px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const GameCard = styled.div`
  min-width: 142px;
  height: 195px;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;

  &:hover {
  

    ${GameOverlay} {
      opacity: 1;
    }
  
    transform: translateY(-5px);

  }

   @media (max-width: 768px) {
   min-width: 115px;
    height: 160px;
  }
`;

const LotteryGameCard = styled.div`
  min-width: 142px;
  height: 106px; // Original height
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;

  &:hover {
    ${GameOverlay} {
      opacity: 1;
    }
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    min-width: 115px;
    height: 80px; // Decreased height for mobile screens
  }
`;

const GameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const LotteryGameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const PlayIconContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PlayIcon = styled(Play)`
  color: #fff;
  font-size: 24px;
`;

const TopTitle = styled.div`
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-left:4px;
`;

const ProviderLogo = styled.img`
object-fit:contain;
height:1.6rem;
width:80%;
`;
const ProviderWrapper = styled.div`
margin-top:50px !important;
margin-bottom:50px !important;
`;
const ProviderHeadingWrapper = styled.div`
margin-top:10px !important;
margin-bottom:10px !important;
display:flex;
justify-content:space-between;
`;

const ProviderGridContainer = styled.div.attrs({ className: 'provide-grid-container' })`
  display: grid;
  gap: 1px;
  background:#03030F;
  
  padding: 1px;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
  
  // Mobile layout (3 columns, scrollable)
  @media (max-width: 767px) {
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    grid-auto-columns: minmax(100px, 1fr);
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }
  
  // Tablet layout (3 columns)
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    grid-auto-columns: minmax(150px, 1fr);
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }
  
  // Desktop layout (9 columns, 2 rows)
  @media (min-width: 1024px) {
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: repeat(2, 1fr);
    overflow: hidden;
  }
`;

const ProviderGridItem = styled(Link)`
  background:#03030F;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 8px;
  scroll-snap-align: start;
  
  @media (max-width: 1023px) {
    aspect-ratio: 16 / 9;
  }
`;

const LotteryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const LotteryInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
  color: white;
`;

const LotteryTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`;

const LotteryPrize = styled.div`
  font-size: 14px;
  color: #ffd700;
  margin-top: 4px;
`;

const LoadMoreButton = styled.button`
  background-color:#03030F;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  margin: 20px auto;
  display: block;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #4a5354;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background-color: ${props => props.disabled ? '#3a3a3a' : '#4a4a4a'};
  color: ${props => props.disabled ? '#777' : 'white'};
  border: none;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  
  &:hover {
    background-color: ${props => props.disabled ? '#3a3a3a' : '#5a5a5a'};
  }
`;

const PaginationInfo = styled.div`
  color: white;
  font-size: 14px;
`;

const SpinnerStyled = styled.div`
  width: ${props => props.size === "sm" ? "16px" : "24px"};
  height: ${props => props.size === "sm" ? "16px" : "24px"};
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

/* ----------------- caching helpers ----------------- */
const CACHE_PREFIX = "jsgames_cache_v1_";
const CACHE_TTL_MS = 1000 * 60 * 60 * 12; // 12 hours

function getCache(key) {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ts) return null;
    if (Date.now() - parsed.ts > (parsed.ttl || CACHE_TTL_MS)) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return parsed.data;
  } catch (e) {
    return null;
  }
}

function setCache(key, data, ttl = CACHE_TTL_MS) {
  try {
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ ts: Date.now(), ttl, data }));
  } catch (e) {
    // ignore localStorage errors
  }
}

/* ----------------- VendorSection (fixed) ----------------- */
const VendorSection = ({
  vendorId,
  displayName,
  games = [],
  pagination,
  loading,
  isMobileView,
  showMore,
  onToggleShowMore,
  onLaunchGame,
  onPaginationPrev,
  onPaginationNext,
  onScrollLeft,
  onScrollRight,
  scrollRef,
  loadedImages,
  onImageLoad
}) => {
  // use the provided scrollRef as the container for IntersectionObserver root when available
  const internalContainerRef = useRef(null);

  useEffect(() => {
    const container = (scrollRef && scrollRef.current) ? scrollRef.current : internalContainerRef.current;
    if (!container) return;

    // query images that still have data-src
    const imgs = container.querySelectorAll('img[data-src]');
    if (!imgs.length) return;

    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          if (src) {
            img.src = src;
            img.removeAttribute('data-src');
            const gid = img.getAttribute('data-gameid');
            img.onload = () => {
              if (gid) onImageLoad(String(gid));
            };
            img.onerror = () => {
              // remove placeholder on error as well
              if (gid) onImageLoad(String(gid));
            };
          }
          observer.unobserve(img);
        }
      });
    }, {
      root: container, // observe relative to the scroll container; if you want viewport, set null
      rootMargin: '200px',
      threshold: 0.01
    });

    imgs.forEach(i => io.observe(i));
    return () => io.disconnect();
  }, [games, onImageLoad, scrollRef]);

  const displayGames = isMobileView ? games : (showMore ? games : games.slice(0, 40));

  return (
    <div style={{ marginTop: "6px" }}>
      <HeaderContainer>
        <TopTitle>{displayName}</TopTitle>
        <HeaderContent>
          <div onClick={onToggleShowMore}>
            <IconBg>
              <div style={{ fontWeight: "bold" }}>{showMore ? "Show Less" : "Show More"}</div>
            </IconBg>
          </div>

          {!showMore && (
            <div style={{ display: "flex", gap: '4px' }}>
              <IconBg onClick={onScrollLeft}><ChevronLeft size={16} /></IconBg>
              <IconBg onClick={onScrollRight}><ChevronRight size={16} /></IconBg>
            </div>
          )}
        </HeaderContent>
      </HeaderContainer>

      {!showMore ? (
        <CarouselContainer>
          <ScrollContainer ref={scrollRef || internalContainerRef}>
            {displayGames?.map((game, idx) => {
              const gid = String(game.id ?? `${vendorId}-${idx}`);
              return (
                <GameCard key={gid} onClick={() => onLaunchGame(game)}>
                  {!loadedImages.has(gid) && <SkeletonLoader />}
                  <GameImage
                    data-gameid={gid}
                    data-src={game.game_icon || ''}
                    alt={`${displayName} ${idx}`}
                    loading="lazy"
                    style={{ display: 'block' }}
                  />
                  <GameOverlay>
                    <PlayIconContainer><PlayIcon /></PlayIconContainer>
                  </GameOverlay>
                </GameCard>
              );
            })}
          </ScrollContainer>
        </CarouselContainer>
      ) : (
        <>
          <GridWrapper>
            {displayGames?.map((game, idx) => {
              const gid = String(game.id ?? `${vendorId}-grid-${idx}`);
              return (
                <GameCard key={gid} onClick={() => onLaunchGame(game)}>
                  {!loadedImages.has(gid) && <SkeletonLoader />}
                  <GameImage
                    data-gameid={gid}
                    data-src={game.game_icon || ''}
                    alt={`${displayName} ${idx}`}
                    loading="lazy"
                    style={{ display: 'block' }}
                  />
                  <GameOverlay>
                    <PlayIconContainer><PlayIcon /></PlayIconContainer>
                  </GameOverlay>
                </GameCard>
              );
            })}
          </GridWrapper>

          <PaginationContainer>
            <PaginationButton onClick={onPaginationPrev} disabled={!pagination || pagination.currentPage <= 1 || pagination.loading}>
              <ChevronLeft size={16} /> Previous
            </PaginationButton>

            <PaginationInfo>
              Page {pagination?.currentPage || 1} of {pagination?.totalPages || 1}
            </PaginationInfo>

            <PaginationButton onClick={onPaginationNext} disabled={!pagination || pagination.currentPage >= pagination.totalPages || pagination.loading}>
              Next <ChevronRight size={16} />
            </PaginationButton>

            {pagination?.loading && <SpinnerStyled size="sm" />}
          </PaginationContainer>
        </>
      )}
    </div>
  );
};

/* ----------------- withSiteConfig wrapper ----------------- */
const withSiteConfig = (WrappedComponent) => {
  return function WithSiteConfigWrapper(props) {
    const { siteConfig } = useSiteConfig();
    return <WrappedComponent {...props} siteConfig={siteConfig} />;
  };
};

/* ----------------- Main Home component ----------------- */
class Home extends Component {
  constructor(props) {
    super(props);
    const loggedStatus = localStorage.getItem('logged') === 'true';
    this._isMounted = false;
    this.state = {
      vendorPagination: {
        evolution: { currentPage: 1, totalPages: 1, loading: false },
        pragmatic: { currentPage: 1, totalPages: 1, loading: false },
        pragmaticlive: { currentPage: 1, totalPages: 1, loading: false },
        spribe: { currentPage: 1, totalPages: 1, loading: false },
        ezugi: { currentPage: 1, totalPages: 1, loading: false },
        ideal: { currentPage: 1, totalPages: 1, loading: false },
        microgaming: { currentPage: 1, totalPages: 1, loading: false },
        pgsoft: { currentPage: 1, totalPages: 1, loading: false },
        hacksaw: { currentPage: 1, totalPages: 1, loading: false },
        jili: { currentPage: 1, totalPages: 1, loading: false },
        netent: { currentPage: 1, totalPages: 1, loading: false },
        Rich88:{ currentPage: 1, totalPages: 1, loading: false},
        EazyGaming: { currentPage: 1, totalPages: 1, loading: false },
        Playtech:{ currentPage: 1, totalPages: 1, loading: false},
        CQ9:{ currentPage: 1, totalPages: 1, loading: false},
        km:{ currentPage: 1, totalPages: 1, loading: false},
        Evoplay:{ currentPage: 1, totalPages: 1, loading: false},
        NextSpin:{ currentPage: 1, totalPages: 1, loading: false},
        BNG:{ currentPage: 1, totalPages: 1, loading: false},
        PgsGaming:{ currentPage: 1, totalPages: 1, loading: false},
      },
      jsEvolution: [],
      jsPragmeticSlots: [],
      jsPragamaticLive: [],
      jsSpribe: [],
      jsEzugi: [],
      jsIdeal: [],
      jsMicrogaming: [],
      jsPgsoft: [],
      jsHacksaw: [],
      jsJili: [],
      jsNetent: [],
      jsRich88: [],
      jsEazygaming: [],
      jsPlaytech:[],
      jsCQ9:[],
      jsKm:[],
      jsEvoplay:[],
      jsNextSpin:[],
      jsBNG:[],
      jsPgsGaming:[],

      showMoreMap: {},

      loading: false,
      message: null,
      isMobileView: window.innerWidth <= 768,
      isLogged: loggedStatus,
      showIframe: false,
      iframeUrl: '',
      iframeLoading: true,
      loadedLiveCasinoImages: new Set(),
      isLoadGames: true
    };

    this.vendorScrollRefs = {
      evolution: React.createRef(),
      pragmatic: React.createRef(),
      pragmaticlive: React.createRef(),
      spribe: React.createRef(),
      ezugi: React.createRef(),
      ideal: React.createRef(),
      microgaming: React.createRef(),
      pgsoft: React.createRef(),
      hacksaw: React.createRef(),
      jili: React.createRef(),
      netent: React.createRef(),
      Rich88: React.createRef(),
      eazygaming: React.createRef(),
      playtech:React.createRef(),
      CQ9:React.createRef(),
      km:React.createRef(),
      Evoplay:React.createRef(),
      NextSpin:React.createRef(),
      BNG:React.createRef(),
      PgsGaming:React.createRef(),
    };

    // binds
    this.handleImageLiveCasinoLoad = this.handleImageLiveCasinoLoad.bind(this);
    this.handleGameLaunchJSGames = this.handleGameLaunchJSGames.bind(this);
    this.fetchJSGamesByVendor = this.fetchJSGamesByVendor.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
    this.handleToggleShowMore = this.handleToggleShowMore.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.initFetchAllVendors = this.initFetchAllVendors.bind(this);
  }

  vendorsConfig = [
    { id: 'spribe', displayName: 'Spribe', stateKey: 'jsSpribe' },
    { id: 'evolution', displayName: 'Evolution', stateKey: 'jsEvolution' },
    { id: 'pragmatic', displayName: 'Pragmatic Slots', stateKey: 'jsPragmeticSlots' },
    { id: 'pragmaticlive', displayName: 'Pragmatic Live', stateKey: 'jsPragamaticLive' },
    { id: 'ezugi', displayName: 'Ezugi', stateKey: 'jsEzugi' },
    { id: 'ideal', displayName: 'Ideal', stateKey: 'jsIdeal' },
    { id: 'microgaming', displayName: 'Microgaming', stateKey: 'jsMicrogaming' },
    { id: 'pgsoft', displayName: 'PGSoft', stateKey: 'jsPgsoft' },
    { id: 'hacksaw', displayName: 'HackSaw', stateKey: 'jsHacksaw' },
    { id: 'jili', displayName: 'Jili', stateKey: 'jsJili' },
    { id: 'netent', displayName: 'Netent', stateKey: 'jsNetent' },
    { id: 'Rich88', displayName: 'Rich 88', stateKey: 'jsRich88' },
    { id: 'EazyGaming', displayName: 'Eazy Gaming', stateKey: 'jsEazygaming' },
    { id: 'Playtech', displayName: 'Playtech', stateKey: 'jsPlaytech' },
    { id: 'CQ9', displayName: 'CQ9', stateKey: 'jsCQ9' },
    { id: 'km', displayName: 'KM', stateKey: 'jsKm' },
    { id: 'Evoplay', displayName: 'Evoplay', stateKey: 'jsEvoplay' },
    { id: 'NextSpin', displayName: 'NextSpin', stateKey: 'jsNextSpin' },
    { id: 'BNG', displayName: 'BNG', stateKey: 'jsBNG' },
    { id: 'PgsGaming', displayName: 'Pgs Gaming', stateKey: 'jsPgsGaming' },
  ];

  componentDidMount() {
    this._isMounted = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (isMobile()) {
      this.setState({ padding: 'p-1' });
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    socket.on(C.USER_INFO, this.handleUserInfo);
    this.requestUserInfo();

    // start sequential fetching
    this.initFetchAllVendors();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    socket.off(C.USER_INFO, this.handleUserInfo);
    this._isMounted = false;
  }

  handleResize() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    this.setState({ isMobileView: width <= 768 });
  }

  handleImageLiveCasinoLoad(gameId) {
    // ensure strings so keys match
    const id = String(gameId);
    this.setState(prev => {
      const set = new Set(prev.loadedLiveCasinoImages);
      set.add(id);
      return { loadedLiveCasinoImages: set };
    });
  }

  async handleGameLaunchJSGames(game) {
    const isLogged = localStorage.getItem('logged') === 'true';
    if (!isLogged) {
      sendNotfication('Please login to play', 'error');
      return;
    }
    this.setState({ loading: true, message: null });
    try {
      const credits = localStorage.getItem('credit') || '0';
      const coins = localStorage.getItem('coin') || 'USDT';
      if (coins !== 'USDT' && coins !== 'INR' && coins !== 'BDT') {
        sendNotfication("Please Swap Into USDT To Play", "error");
        this.setState({ loading: false });
        return;
      }
      const requestPayload = {
        game_uid: game.game_uid,
        user_id: getUID(),
        credit_amount: credits,
        currency_code: coins,
        language: "en",
      };
      const token = localStorage.getItem('token');
      const response = await fetch('https://api.ibitplay.com/jsGamesv2/launch', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(requestPayload),
      });
      if (!response.ok) {
        sendNotfication("Game under maintenance", "error");
      }
      const result = await response.json();
      if (result.success && result.data.game_launch_url) {
        this.setState({
          iframeUrl: result.data.game_launch_url,
          showIframe: true,
          iframeLoading: true,
        });
      }
    } catch (err) {
      this.setState({ message: { type: 'error', text: err.message } });
    } finally {
      this.setState({ loading: false });
      setTimeout(() => this.setState({ message: null }), 5000);
    }
  }

  requestUserInfo = () => {
    socket.emit(C.USER_INFO, encode({
      id: getUID(),
      coin: storage.getKey('coin') || '',
      rate: null,
      game: 'all',
      first: true
    }));
  };

  handleUserInfo = (data) => {
    const decodedData = decode(data);
    if (decodedData.status) this.setState({ userData: decodedData });
  };

  async fetchJSGamesByVendor(vendorName, page = 1, perPage = 20, force = false) {
    const cacheKey = `${vendorName}_p${page}_per${perPage}`;
    if (!force) {
      const cached = getCache(cacheKey);
      if (cached) {
        return { games: cached.games || [], pagination: cached.pagination || { current_page: page, per_page: perPage, total: cached.games.length, total_pages: Math.ceil((cached.games || []).length / perPage) } };
      }
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://api.ibitplay.com/jsGames/games?vendor=${vendorName}&page=${page}&per_page=${perPage}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();
      if (result.success && result.payload && result.payload.games) {
        const games = result.payload.games;
        const pagination = result.payload.pagination || {
          current_page: page,
          per_page: perPage,
          total: games.length,
          total_pages: Math.ceil(games.length / perPage)
        };

        setCache(cacheKey, { games, pagination });

        return { games, pagination };
      } else {
        throw new Error("No games found or invalid response");
      }
    } catch (err) {
      console.error(`Error fetching ${vendorName} games:`, err.message);
      return { games: [], pagination: { current_page: 1, per_page: perPage, total: 0, total_pages: 0 } };
    }
  }

  async initFetchAllVendors() {
    const vendors = this.vendorsConfig.map(v => v.id);

    for (const vendor of vendors) {
      if (!this._isMounted) break;

      this.setState(prev => ({ vendorPagination: { ...prev.vendorPagination, [vendor]: { ...(prev.vendorPagination[vendor] || {}), loading: true } } }));

      try {
        const result = await this.fetchJSGamesByVendor(vendor, 1, 20);
        const conf = this.vendorsConfig.find(v => v.id === vendor);
        if (conf) {
          this.setState({
            [conf.stateKey]: result.games,
            vendorPagination: {
              ...this.state.vendorPagination,
              [vendor]: {
                currentPage: result.pagination.current_page || 1,
                totalPages: result.pagination.total_pages || 1,
                loading: false
              }
            }
          });

          // warm first few images
          (result.games || []).slice(0, 6).forEach(g => {
            if (g && g.game_icon) {
              const img = new Image();
              img.src = g.game_icon;
            }
          });
        }
      } catch (err) {
        this.setState(prev => ({ vendorPagination: { ...prev.vendorPagination, [vendor]: { ...(prev.vendorPagination[vendor] || {}), loading: false } } }));
      }
      // tiny gap to avoid bursts
      await new Promise(r => setTimeout(r, 120));
    }

    if (this._isMounted) this.setState({ isLoadGames: false });
  }

  async handlePagination(vendor, direction) {
    const stateKey = this.vendorsConfig.find(v => v.id === vendor)?.stateKey;
    if (!stateKey) return;
    const vendorPagination = { ...this.state.vendorPagination };
    const pagination = vendorPagination[vendor];
    let targetPage = direction === 'next' ? pagination.currentPage + 1 : pagination.currentPage - 1;
    if (targetPage < 1 || targetPage > pagination.totalPages || pagination.loading) return;

    vendorPagination[vendor].loading = true;
    this.setState({ vendorPagination });

    try {
      const result = await this.fetchJSGamesByVendor(vendor, targetPage, 20, true);
      vendorPagination[vendor] = {
        currentPage: result.pagination.current_page,
        totalPages: result.pagination.total_pages,
        loading: false
      };
      this.setState({ [stateKey]: result.games, vendorPagination });
      (result.games || []).slice(0, 6).forEach(g => { if (g && g.game_icon) { new Image().src = g.game_icon; } });
    } catch (err) {
      console.error(`Error navigating ${vendor} games:`, err);
      vendorPagination[vendor].loading = false;
      this.setState({ vendorPagination });
    }
  }

  handleToggleShowMore(vendorId) {
    this.setState(prev => {
      const showMoreMap = { ...prev.showMoreMap };
      showMoreMap[vendorId] = !showMoreMap[vendorId];
      return { showMoreMap };
    });
  }

  handleScroll(vendorId, dir = 'left') {
    const ref = this.vendorScrollRefs[vendorId];
    if (ref && ref.current) {
      ref.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
    }
  }

  render() {
    const { loading, message, isMobileView, showIframe, iframeUrl, iframeLoading, loadedLiveCasinoImages } = this.state;

    const getGamesFor = (stateKey) => this.state[stateKey] || [];
    const getPaginationFor = (vendorId) => this.state.vendorPagination[vendorId] || { currentPage: 1, totalPages: 1, loading: false };
    const showMoreMap = this.state.showMoreMap || {};

    if (showIframe) {
      const imageStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '250px',
        animation: 'fadeinout 2s infinite',
      };
      const animationStyle = `
        @keyframes fadeinout {
          0%, 100% { opacity: 0; }
          50% { opacity: 1; }
        }
      `;
      return (
        <FullScreenContainer>
          <style>{animationStyle}</style>
          {this.state.iframeLoading && (<img src="./assets/betlover365.png" alt="Loading" style={imageStyle} />)}
          <FullScreenIframe src={iframeUrl} title="Game Iframe" onLoad={() => this.setState({ iframeLoading: false })} loading={this.state.iframeLoading} />
          <BackButton onClick={() => { this.setState({ showIframe: false, iframeUrl: '', iframeLoading: true }); }}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </BackButton>
        </FullScreenContainer>
      );
    }

    return (
      <>
        <Helmet>
          <title>{BRAND} - Crypto Casino Games and Crypto Gambling</title>
          <meta name="keywords" content="WEB 3.0 Crypto Casino Games, Online Casino Games, Bitcoin Crash Game, Dice Games, Live Casino Games, Crypto Casino Games, Blockchain Games, Bitcoin Casino Games, Best Crypto Online Game, Crypto Gambling Games" />
          <meta name="description" content="PlayCrash.com is built by gamblers for gamblers. With our unique community and a huge selection of games like Crash, HashDice, Plinko, Slots, and many more." />
        </Helmet>

        {this.props.content}

        <div style={{ marginTop: '-10px' }}>
          <div style={{ marginTop: "24px" }}>
            {!isMobileView ? <PaymentBar /> : <MobilePaymentBR />}
          </div>

          {this.vendorsConfig.map(vendor => {
            const games = getGamesFor(vendor.stateKey);
            const pagination = getPaginationFor(vendor.id);
            const showMore = !!showMoreMap[vendor.id];
            const scrollRef = this.vendorScrollRefs[vendor.id];
            return (
              <VendorSection
                key={vendor.id}
                vendorId={vendor.id}
                displayName={vendor.displayName}
                games={games}
                pagination={pagination}
                loading={pagination.loading}
                isMobileView={isMobileView}
                showMore={showMore}
                onToggleShowMore={() => this.handleToggleShowMore(vendor.id)}
                onLaunchGame={this.handleGameLaunchJSGames}
                onPaginationPrev={() => this.handlePagination(vendor.id, 'prev')}
                onPaginationNext={() => this.handlePagination(vendor.id, 'next')}
                onScrollLeft={() => this.handleScroll(vendor.id, 'left')}
                onScrollRight={() => this.handleScroll(vendor.id, 'right')}
                scrollRef={scrollRef}
                loadedImages={loadedLiveCasinoImages}
                onImageLoad={this.handleImageLiveCasinoLoad}
              />
            );
          })}

          <GameProviders />
        </div>

        <CasinoLeaderboard />

        {loading && (
          <div className="d-flex justify-content-center align-items-center" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
            <SpinnerStyled />
          </div>
        )}

        {message && (
          <Alert variant={message.type === 'error' ? 'danger' : 'success'} style={{ position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
            {message.text}
          </Alert>
        )}
      </>
    );
  }
}

function HomeWithContext(props) {
  return <Home {...props} />;
}

export default withCookies(HomeWithContext);
